import { Box, CircularProgress, Typography } from "@mui/material";
import { GraduationCap } from "lucide-react";

interface Props {
  visible: boolean;
  message?: string;
}

export function TutorialToast({ visible, message = "곧 튜토리얼이 시작됩니다..." }: Props) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#1e1e2e",
        color: "#fff",
        px: 2,
        py: 1,
        borderRadius: 2,
        fontSize: "13px",
        display: "flex",
        alignItems: "center",
        gap: 1,
        boxShadow: 4,
        zIndex: 9999,
      }}
    >
      <CircularProgress size={14} sx={{ color: "#fff" }} />
      <GraduationCap size={14} />
      <Typography sx={{ fontSize: "13px", color: "#fff" }}>{message}</Typography>
    </Box>
  );
}
